import { Theme, createTheme } from "@mui/material/styles";

import { getColor } from "@hooks/useColors";
import background_dark from "@public/portfolio_automation/flares_automation_dark.png";
import background_light from "@public/portfolio_automation/flares_automation_light.png";
import { darkTheme, lightTheme } from "@themes";

const commonTheme = (theme: Theme) => ({
  palette: {
    background: {
      default: getColor(c => c.tokens.bg["weak-50"], theme),
      paper: getColor(c => c.tokens.bg["weak-50"], theme),
    },
  },
  background: {
    image: theme.palette.mode === "light" ? background_light : background_dark,
    blurBox: getColor(c => c.foundations.alpha.purple["alpha-10"], theme),
  },
  footerBackgroundGradient:
    "radial-gradient(44.06% 50% at 50% 0%, rgba(149, 115, 245, 0.08) 0%, rgba(150, 197, 240, 0.04) 100%)",
  card: {
    shadow: getColor(c => c.foundations.purple[400], theme),
  },
  metricCard: {
    color: getColor(c => c.foundations.alpha.purple["alpha-10"], theme),
  },
  portfolio: {
    header:
      theme.palette.mode === "light"
        ? {
            borderColor_100: getColor(c => c.foundations.purple[100], theme),
            borderColor_200: getColor(c => c.foundations.purple[200], theme),
            borderColor_300: getColor(c => c.foundations.purple[300], theme),
          }
        : {
            borderColor_100: "#FFFFFF1A",
            borderColor_200: "#FFFFFF33",
            borderColor_300: "#FFFFFF4D",
          },
    subheader: {
      gradient: getColor(c => c.gradients.automation.linear, theme),
    },
  },
});

export const automationDarkTheme = createTheme(
  darkTheme,
  commonTheme(darkTheme),
);
export const automationLightTheme = createTheme(
  lightTheme,
  commonTheme(lightTheme),
);
